import React, { Component } from 'react';
import Radio from "./radio";
import { Col, Row } from 'react-bootstrap';


export default class EventView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventViews: props.data,
    };
  }

  handleChange = (value, index) => {
    this.setState(
      ({ eventViews }) => ({
        eventViews: eventViews.map((a, idx) =>
          idx === index ? { ...a, checked: true } : { ...a, checked: false }
        )
      })
    );

    let event_view = { ...this.props.values.event_view }
    event_view[value.target.value] = true
    this.props.onChange("event_view", {});
    this.props.onChange("event_view", event_view)
  };

  render() {
    return (
      <div>
        <Row>
          <Col>
            <h4 className="ui centered question-header text-center">Do you have a preference for how attendees view your
              event?</h4>
          </Col>
        </Row>
        <Row md="3" sm="2" xs="1">
          {
            this.state.eventViews.map((type, index) => (
              <Radio
                attendee={type}
                name="event_view"
                key={type.value}
                onChange={(value) => this.handleChange(value, index)}
                {...type}
              />
            ))
          }
        </Row>
      </div>
    )
  }
}
